import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import React, { useState } from "react";
import emailjs from "emailjs-com";

function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    const templateParams = {
      name,
      email,
      message: `${message}\n\n${email}`,
    };
    emailjs

      .send(
        "service_6lvqgvu",

        "template_txo275o",

        templateParams,
        "57DvOsKIs3wjsYa83"
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Email sent successfully!");
        },
        (error) => {
          console.log(error.text);
          alert("Error sending email: " + error.text);
        }
      );
    setName("");
    setEmail("");
    setMessage("");
  };
  return (
    <section
      id="services"
      style={{
        backgroundColor: "#f7f7f7",
        overflow: "hidden",
        minHeight: "100vh",
      }}
      className="d-flex justify-content-start align-items-center flex-column"
    >
      <div
        style={{
          backgroundColor: "rgb(15, 12, 31)",
          padding: "20px",
          width: "100%",
          color: "#fff",
          marginBottom: "5rem",
        }}
      >
        <h3 className="mb-2 text-center">Contact</h3>
        <p className="text-center">
          For any projects and collaborations, feel free to drop me an email. I
          would love to hear from you
        </p>
      </div>
      <Container className="d-flex justify-content-center align-items-center">
        <Card
          className="lift-card "
          id="contact1"
          style={{
            borderRadius: "1rem",
          }}
        >
          <Card.Body>
            <Container>
              <h2 className="mt-3 mb-3 text-center">Drop an email</h2>
              <Row>
                <Col className="d-flex justify-content-center align-items-center">
                  <div className="contact-form">
                    <p className="mt-3 mb-3 text-center">
                      {" "}
                      I will get to you swiftly
                    </p>

                    <div id="contact-form">
                      <form onSubmit={handleSubmit}>
                        <Row className="wow fadeInUp mb-3" data-wow-delay="1s">
                          <Col>
                            <input
                              name="fullname"
                              type="text"
                              className="form-control"
                              id="fullname"
                              placeholder="Your Name"
                              value={name}
                              onChange={(event) => setName(event.target.value)}
                              style={{ borderColor: "#000" }}
                            />
                          </Col>
                          <Col>
                            <input
                              name="email"
                              type="email"
                              className="form-control"
                              id="email"
                              placeholder="Your Email"
                              value={email}
                              onChange={(event) => setEmail(event.target.value)}
                              style={{ borderColor: "#000" }}
                            />
                          </Col>
                        </Row>
                        <div
                          className="wow fadeInUp mb-3"
                          data-wow-delay="1.4s"
                        >
                          <textarea
                            name="message"
                            rows="4"
                            className="form-control"
                            id="message"
                            placeholder="Write your message..."
                            value={message}
                            onChange={(event) => setMessage(event.target.value)}
                            style={{ borderColor: "#000" }}
                          ></textarea>
                        </div>
                        <div
                          className=" wow fadeInUp col-md-6 col-sm-8 "
                          data-wow-delay="1.6s"
                          style={{
                            marginLeft: "auto",
                            marginRight: "auto",
                          }}
                        >
                          <Button
                            type="submit"
                            className="form-control"
                            id="submit"
                            style={{
                              background: "rgb(15, 12, 31)",
                              borderColor: "rgb(15, 12, 31)",
                            }}
                          >
                            Send
                          </Button>
                        </div>
                      </form>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Card.Body>
        </Card>
      </Container>
    </section>
  );
}

export default Contact;
